const DividerDecoration = () => {
  return <div className="divider-circle mt-4" />;
};

export default DividerDecoration;
